import React from "react";
import {faAngleRight, faDownload, faSpinner} from "@fortawesome/pro-solid-svg-icons";
import {Get, OpenFile} from "../../components/request";
import screens from "../../screens";
import ScreenComponent from "../../components/screenComponent";
import {withRouter} from "react-router-dom";
import IconTitle from "../../components/iconTitle";
import {getFile, getFileIcon} from "../../components/utils";
import Moment from "moment";
import {Alert} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

class DownloadDocument extends ScreenComponent {

    constructor(props) {
        super(props);

        this.state = {
            files: [],
            loading: false,
        }
    }

    async componentDidMount() {
        super.componentDidMount();
        this.setState({loading: true});

        const {body} = await Get(`/v1/extranet/student/${screens.Inscriptions}`);

        var files = [];

        for (const item of body) {
            var result = [];
            const {body} = await Get(`/v1/extranet/student/${screens.Inscription}03/${item.InscriptionID}`);
            result.item = item;
            result.files = body;

            files.push(result);
        }

        this.setState({
            files: files,
            loading: false,
        });
    }

    componentDidUpdate(prevProps: Readonly<P>, prevState: Readonly<S>, snapshot: SS) {
        if (this.props.search !== prevProps.search) this.componentDidMount();
    }

    renderFiles(item, key) {

        let filesToShow = item.files;

        if (this.props.isVerification) {
            filesToShow = item.files
                .filter(f => {
                    const name = f.FullName.toLowerCase();
                    return name.startsWith("relevenotes") && !name.startsWith("relevenotesen");
                })
                .sort((a, b) => new Date(b.LastModified) - new Date(a.LastModified)) //plus récent en premier
                .slice(0, 1); // garder le premier resultat
        }

        return (
            <div className="mb-5" key={key}>
                <IconTitle
                    icon={faAngleRight}
                    type="h5"
                    content={`${item.item.AnneeAcademiqueValeur} / ${item.item.NiveauCoursLibelle}`}
                />
                <div style={{ margin: "2rem 3.8rem 0" }}>
                    {filesToShow.length > 0 ? filesToShow.map((m, idx) => (
                        <IconTitle
                            icon={getFileIcon(m.ContentType)}
                            key={idx}
                            type="h6"
                            content={
                                <>
                                    <a
                                        onClick={async (e) => {
                                            e.preventDefault();
                                            if (this.props.isVerification) {
                                                let newWindow = await OpenFile(
                                                    `/v1/files/printDocument/${item.item.InscriptionID}/${m.Name + m.Extension.replace('.', ',')}`
                                                );
                                                newWindow.document.title = `${this.props.matricule} - ${item.item.AnneeAcademiqueValeur} / ${item.item.NiveauCoursLibelle} - ${m.Name}`;
                                            } else {
                                                getFile(item.item.InscriptionID, m.Name + m.Extension.replace('.', ','));
                                            }
                                        }}
                                    >
                                        {m.FullName}
                                    </a>
                                    <span className="d-inline ml-4 blockquote-footer">
                                        {Moment(m.LastModified).format("DD/MM/YYYY HH:mm:ss")}
                                    </span>
                                </>
                            }
                        />
                    )) : "(aucun fichier)"}
                </div>
            </div>
        );
    }

    renderDownload() {
        return (
            <>
                {this.state.files.reverse().map((m, key) => {
                    if (this.props.isVerification &&
                        !m.files.some(f => f.FullName.toLowerCase().startsWith("relevenotes"))) return null;

                    return this.renderFiles(m, key);
                })}
            </>
        )
    }

    render() {
        return (
            <section>
                {!this.props.isVerification &&
                    <IconTitle icon={faDownload} type={"h3"} content={"Fichiers téléchargeables"}/>}
                {!this.props.isVerification && <Alert variant={"secondary"} style={{margin: "2rem 0 3rem"}}>
                    Pour obtenir les attestations pour l'année académique en cours, votre inscription doit être régulière. Ce qui suppose de respecter les conditions de l’article 100 (Signature du PAE) et de l’article 102, § 1er, alinéa 1er (Réception effective sur
                    notre compte bancaire d'un paiement de minimum 50 euros). <small><i>(l'acompte de vos droits
                    d'inscription)</i></small><br/>
                    Les relevés de notes sont mis-à-jour automatiquement <b>quelques jours après</b> la diffusion des points.
                </Alert>}
                {this.state.loading
                    ? <FontAwesomeIcon icon={faSpinner} className={"fa-3x"} pulse={true} style={{margin: "4.5rem"}}/>
                    : this.renderDownload()}
            </section>
        );
    }
}

export default withRouter(DownloadDocument);